"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var DataTable = /*#__PURE__*/function (_Component) {
  _inherits(DataTable, _Component);

  var _super = _createSuper(DataTable);

  function DataTable() {
    _classCallCheck(this, DataTable);

    return _super.apply(this, arguments);
  }

  _createClass(DataTable, [{
    key: "render",
    value: function render() {
      var _this = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var data = this.props.data || [];
      var columns = this.props.columns;
      var rows = data.map(function (item, index) {
        return columns.map(function (column) {
          return column.render ? column.render(item, index) : item[column.key];
        });
      });

      var headingElements = /*#__PURE__*/_react.default.createElement("tr", null, columns.map(function (column, index) {
        return /*#__PURE__*/_react.default.createElement("th", {
          className: _this.constructor.BASE_CLASS + '__heading',
          key: index,
          width: column.width
        }, /*#__PURE__*/_react.default.createElement(_.Pretitle, null, column.label));
      }));

      var rowsElements = rows.map(function (row, index) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          className: _this.constructor.BASE_CLASS + '__row',
          key: index
        }, row.map(function (cell, index) {
          return /*#__PURE__*/_react.default.createElement("td", {
            className: _this.constructor.BASE_CLASS + '__value',
            key: index
          }, cell);
        }));
      });
      return /*#__PURE__*/_react.default.createElement("table", {
        className: this.getClassNames(),
        style: this.getStyle()
      }, /*#__PURE__*/_react.default.createElement("thead", null, headingElements), /*#__PURE__*/_react.default.createElement("tbody", null, rowsElements));
    }
  }]);

  return DataTable;
}(_component.default);
/*---------------------------------------------*/


exports.default = DataTable;

_defineProperty(DataTable, "BASE_CLASS", 'lth-c-datatable');

DataTable.METADATA = {
  name: 'DataTable',
  props: [{
    name: 'columns'
  }, {
    name: 'render'
  }, {
    name: 'data'
  }],
  demo: {
    props: {
      columns: [{
        key: 'title',
        label: 'Title'
      }, {
        key: 'date',
        label: 'Date',
        render: function render(item) {
          return "" + new Date(item.date);
        }
      }, {
        key: 'time',
        label: 'Time'
      }, {
        key: null,
        label: '',
        render: function render(item) {
          return /*#__PURE__*/_react.default.createElement(_.Icon, {
            size: 14,
            icon: "edit",
            style: {
              verticalAlign: 'initial'
            }
          });
        }
      }],
      data: [{
        title: 'Event 1',
        date: 1 * new Date(),
        time: '10:00'
      }, {
        title: 'Event 2',
        date: 1 * new Date(),
        time: '00:00'
      }, {
        title: 'Event 3',
        date: 1 * new Date(),
        time: '20:00'
      }]
    }
  },
  content: {
    default: {}
  }
};